export const EXTRA_CREDIT_PACK = { credits: 200, price: 50 };

export type LimitIcon = "storage" | "credits" | "branches" | "staff";

export const plans: {
  name: string;
  audience: string;
  prices: { monthly: number; yearly: number } | null;
  limits: { icon: LimitIcon; text: string }[];
  features: string[];
  extraCreditCap?: number;
  capacity?: { storage: number; credits: number; branches: number; staff: number; advanced: boolean };
  featured?: boolean;
}[] = [
  {
    name: "Starter",
    capacity: { storage: 2000, credits: 500, branches: 1, staff: 0, advanced: false },
    extraCreditCap: 400,
    audience: "For single-outlet businesses ready to automate",
    prices: { monthly: 80, yearly: 65 },
    limits: [
      { icon: "storage", text: "2,000 contacts storage" },
      { icon: "credits", text: "500 AI credits" },
      { icon: "branches", text: "1 branch" },
      { icon: "staff", text: "No staff accounts" },
    ],
    features: [
      "Omnichannel inbox",
      "Hyper-personalised contact profiles",
      "Standard workflows (1 credit)",
      "App integrations (e.g. WhatsApp, IG)",
      "Custom terminologies",
    ],
  },
  {
    name: "Growth",
    capacity: { storage: 8000, credits: 1000, branches: 2, staff: 5, advanced: true },
    extraCreditCap: 600,
    audience: "For fast-scaling teams adding new branches",
    prices: { monthly: 200, yearly: 160 },
    limits: [
      { icon: "storage", text: "8,000 contacts storage" },
      { icon: "credits", text: "1,000 AI credits" },
      { icon: "branches", text: "2 branches" },
      { icon: "staff", text: "5 staff accounts" },
    ],
    features: [
      "Everything in Starter, plus",
      "Advanced workflows (3 credits)",
      "Broadcasts (3 credits)",
      "Custom MCP / API integrations",
      "Ask Dibs AI",
    ],
    featured: true,
  },
  {
    name: "Premium",
    capacity: { storage: 30000, credits: 2000, branches: 5, staff: 15, advanced: true },
    extraCreditCap: 1000,
    audience: "For established businesses that want greater control",
    prices: { monthly: 600, yearly: 480 },
    limits: [
      { icon: "storage", text: "30,000 contacts storage" },
      { icon: "credits", text: "2,000 AI credits" },
      { icon: "branches", text: "5 branches" },
      { icon: "staff", text: "15 staff accounts" },
    ],
    features: [
      "Everything in Growth, plus",
      "Multi-branch reporting",
      "Data exports and back ups",
    ],
  },
  {
    name: "Enterprise",
    audience: "For large organisations",
    prices: null,
    limits: [
      { icon: "storage", text: "Custom contacts storage" },
      { icon: "credits", text: "Custom AI credits" },
      { icon: "branches", text: "Custom branches" },
      { icon: "staff", text: "Custom staff accounts" },
    ],
    features: [],
  },
];

export const additionalAddOns: { name: string; price: number; unit?: string; description: string; logo?: string; icon?: "credits"; note?: string }[] = [
  { name: "Extra AI credits", price: EXTRA_CREDIT_PACK.price, unit: `${EXTRA_CREDIT_PACK.credits} credits`, description: "Max extras / month: 400 on Starter, 600 on Growth, 1,000 on Premium.", note: "Unused credits roll over 20% for up to 1 month.", icon: "credits" },
  { name: "Dibs Bookings", price: 30, description: "Our in-house booking system for seamless scheduling.", logo: "/dibs_assets/red_logo_with_transparent_bg.png" },
  { name: "Business numbers", price: 20, description: "Need a dedicated business number? Get one from us." },
];
